import Box, { BoxProps } from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import React, { memo, ReactNode } from 'react';

interface IProps extends BoxProps {
  children?: ReactNode | ReactNode[];
  bgContent?: boolean;
  contentProps?: BoxProps;
}

const Card = memo<IProps>((props) => {
  const { children, bgContent, contentProps, ...others } = props;

  return (
    <Box component={Paper} padding={1} bgcolor='#f6f6f6' boxShadow={0} {...others}>
      {bgContent
        ? (
          <Box component={Paper} padding={1} bgcolor='common.white' boxShadow={0} {...contentProps}>
            {children}
          </Box>
        )
        : children
      }
    </Box>
  );
});

export default Card;